import ProjectModel from "@/models/lab/ProjectModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * Project collection
 */
export default class ProjectCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ProjectModel;
  }

}
